// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"453":"cdfed5f1","725":"9b6d4853","901":"a15f3dfa","930":"1175bf2d","992":"9de84b0c"}[chunkId] + ".chunk.js";
};